import React from 'react';
import { IntlProvider } from 'react-intl';
import { Helmet } from 'react-helmet';
import { BreakpointProvider } from 'react-socks';
import { ScreenClassProvider } from 'react-grid-system';
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/de';
import de from '../../locales/de/messages.json';
import en from '../../locales/en/messages.json';
import fr from '../../locales/fr/messages.json';
import { flattenMessages } from '../_helpers';
import SEO from '../../components/modules/SEO/SEO';
import { LanguageProvider, ContactProvider } from '../../providers';
import { GlobalProvider } from '../../providers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const messages = {
  de,
  en,
  fr
};
const BaseLayout = _ref => {
  let {
    children,
    pageContext,
    locale
  } = _ref;
  const lang = pageContext ? pageContext.lang : locale;
  return ___EmotionJSX(IntlProvider, {
    locale: lang,
    defaultLocale: 'de',
    messages: flattenMessages(messages[lang])
  }, ___EmotionJSX(LanguageProvider, {
    currentLang: lang
  }, ___EmotionJSX(ContactProvider, null, ___EmotionJSX(GlobalProvider, null, ___EmotionJSX(SEO, null), ___EmotionJSX(Helmet, null, ___EmotionJSX("meta", {
    "http-equiv": "X-UA-Compatible",
    content: "IE=edge"
  }), ___EmotionJSX("meta", {
    name: "format-detection",
    content: "telephone=no"
  })), ___EmotionJSX(ScreenClassProvider, null, ___EmotionJSX(BreakpointProvider, null, children))))));
};
export default BaseLayout;